<!-- section start -->
<section class="single-blog-head bg-webp" data-image-src="assets/images/breadcrumb" style="background-image:url('./assets/images/breadcrumb.jpg')">
    <div class="container">
        <div class="row m-t-50 m-b-0">
            <div class="col-12">
                <div class="title title2 title-inner">
                    <div class="main-title">
                        <h2 class="borders text-center color-000"><span>Go Pro Cameras</span></h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="agency blog-sec blog-sidebar single_blog_item">
    <div class="container">
        <div class="blog-text">
            <h6>July, 24th 2018</h6>
            <a href="javascript:void()">
                <h3 class="blog-head">Sandford Stadium Improvements</h3>
            </a>
            <div class="blog-divider"></div>
            <div class="blog-description border-0 pb-0">

                <div class="row">
                    <div class="col-lg-8">
                        <div class="box-iframe">
                            <div class="embed-responsive embed-responsive-16by9">
                                <iframe class="embed-responsive-item" src="https://www.google.com/maps/embed?pb=!4v1583506817046!6m8!1m7!1sCAoSLEFGMVFpcE5TSDFVY2w4Z002SWJud0NtYzVpeVFXcklNbTBIRVVnaXIyb3hZ!2m2!1d47.39428638743545!2d8.474812067637572!3f286.3525765973367!4f-9.24510506502692!5f0.7820865974627469"></iframe>
                            </div>
                        </div>
                    </div>
                </div>                
            </div>
        </div>
    </div>
</section>
<!-- section start -->